import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IMAGES } from "../images/images";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const Footer = () => {
  const handleFooterNavClick = (e, targetPath) => {
    e.preventDefault();
    const targetId = targetPath.replace("/", "");
    const baseURL = window.location.origin + "/";

    if (window.location.pathname !== "/") {
      // Store scroll target if user is not on home page
      if (!sessionStorage.getItem("scrollToSection")) {
        sessionStorage.setItem("scrollToSection", targetId);
        window.location.href = baseURL;
      }
    } else {
      // If already on home, scroll to the section
      const element = document.getElementById(targetId);
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: "smooth",
        });
      }
    }
  };

  const data = [
    { pageName: "/home", title: "Home" },
    { pageName: "/about", title: "About" },
    { pageName: "/features", title: "Features" },
    { pageName: "/app", title: "Download Our App" },
  ];

  return (
    <section className="footer">
      <Container fluid>
        <Row>
          <Col lg={3} md={6} className="mb-lg-0 mb-4">
            <Image src={IMAGES.Logo} />
            <p className="abText">
              Chummy helps you find real friends based on your personality and
              shared interests...
            </p>
            <div className="socialLinks">
              <Link><Icon icon="bx:bxl-instagram-alt" /></Link>
              <Link><Icon icon="akar-icons:twitter-fill" /></Link>
              <Link><Icon icon="bx:bxl-facebook" /></Link>
            </div>
          </Col>

          <Col lg={3} md={6} xs={6} className="mb-lg-0 mb-4">
            <h3>Quick Links</h3>
            <ul>
              {data.map((item, index) => (
                <li key={index}>
                  <a href={item.pageName} onClick={(e) => handleFooterNavClick(e, item.pageName)}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={3} md={6} xs={6} className="mb-lg-0 mb-4">
            <h3>Useful links</h3>
            <ul>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-lg-0 mb-4">
            <h3>Contact Info</h3>
            <ul>
              <li>demouser@gmail.com</li>
              <li>(+01) 123-345-4567</li>
            </ul>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="copyright">
              <p>Copyright © 2025. All Rights Reserved</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Footer;
